import { MessageBox, Message } from "element-ui";
import debounce from "lodash.debounce";

/**
 * 默认分页参数
 */
export const pagingParamsFactory = () => ({
  pageSize: 10,
  pageNum: 1
});

/**
 * 获取分页参数，pageInput
 * @param paging
 */
export const getPageInput = (paging: any = {}) => {
  const { pageNum, pageSize } = paging;
  return { pageNum, pageSize };
};

/**
 * 获取分页数据
 * @param res
 */
export const getResPaginationData = (res: any = {}) => {
  const {
    data: {
      api: { dataList = [], pageInfo: { totalCount: total = 0 } = {} } = {}
    }
  } = res;
  return { list: (dataList || []).map(o => o.node), total };
};

/**
 * 获取接口返回数据
 * @param res
 */
export const getResData = (res: any = {}) => {
  return res.data.data;
};

/**
 * 返回指定字段的对象
 * @param obj
 * @param fields 需要的字段数组
 */
export const filterFields = (obj = {}, fields = []) => {
  return Object.assign(
    {},
    ...Object.keys(obj)
      .filter(key => fields.includes(key))
      .map(key => ({ [key]: obj[key] }))
  );
};

/**
 * 过滤 null 和 undefined 和 空串
 * @param obj
 * @param reference 是否过滤引用类型。过滤 []、{}
 */
export const clearEmptyAttr = (obj = {}, reference = false) => {
  return Object.assign(
    {},
    ...Object.keys(obj)
      // filter process
      .filter(key => {
        let value = obj[key];
        const hasVal = !["", null, undefined].includes(value);
        // filter reference
        if (reference && typeof value === "object" && value) {
          if (Array.isArray(value)) {
            if (value.length) {
              obj[key] = value.map(o =>
                typeof o === "object" ? clearEmptyAttr(o, reference) : o
              );
            }
            return !!value.length;
          } else {
            clearEmptyAttr(value, reference);
            return !!Object.keys(value).length;
          }
        }
        return hasVal;
      })
      // final key
      .map(key => ({ [key]: obj[key] }))
  );
};

/**
 * 确认弹窗
 * @param options
 */
export const showConfirmDialog = (options?: any) => {
  const {
    title = "",
    message = "确认操作吗",
    confirmButtonText = "确定",
    cancelButtonText = "取消",
    type = "warning"
  } = options || {};
  return MessageBox.confirm(message, title, {
    confirmButtonText,
    cancelButtonText,
    type
  });
};

/**
 * 查找数据中的属性值
 * @param arr
 * @param value
 */
export const findValueInArray = (arr = [], value: any, options?: any) => {
  const { valueKey = "value", labelKey = "label" } = options || {};
  for (const item of arr) {
    if (item[valueKey] === value) {
      return item[labelKey];
    }
  }
  return "";
};

//获取uuid
export const getUuid = (len, radix) => {
  let chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  let uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;

    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
};

/**
 * 使用组合模式
 * @param fnArray
 */
export const callLinkedFn = async function (...fnArray: Function[]) {
  let res: any;
  for (const fn of fnArray) res = await fn(res);
  return res;
};

/**
 * 防抖，默认是立即执行
 * @param fn 执行函数
 * @param time 控制时间
 * @param options 自定义参数
 */
export const debounceFactory = (fn: Function, time?: number, options?: any) => {
  return debounce(
    fn,
    time || 2000,
    options || {
      leading: true,
      trailing: false
    }
  );
};

/**
 * url 文件下载
 * @param url
 */
export const downloadUrl = (url: string) => {
  if (!url) return;
  let el = document.createElement("a");
  el.download = url;
  el.style.display = "none";
  el.href = url;
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};
